import { faFaceAnxiousSweat } from '@fortawesome/pro-duotone-svg-icons';
import { IconButton, styled } from '@mend/mui';
import { DarkMode, LightMode } from '@mui/icons-material';
import { Link, Tooltip, useTheme } from '@mui/material';
import { Outlet } from 'react-router';

import { config } from '#config.ts';
import logoDarkUrl from '../assets/logo-dark.svg';
import logoLightUrl from '../assets/logo-light.svg';
import {
  Description as StatusMessageDescription,
  Root as StatusMessageRoot,
} from '../components/StatusMessage.tsx';
import { useThemeMode } from '../lib/ThemeProvider.tsx';

const StyledNav = styled('nav')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(4, 3),
  boxShadow: theme.shadows[3],
  // One-off colors
  backgroundColor: theme.palette.mode === 'dark' ? '#001923de' : '#fffffff2',
}));

const Logo = styled('img')({
  display: 'block',
});

const Content = styled('main')(({ theme }) => ({
  // The `104px` is the height of the nav bar, if it changes, this needs to be
  // updated.
  height: 'calc(100% - 104px)',
  padding: theme.spacing(3),
}));

function Nav() {
  const theme = useTheme();
  const { toggle } = useThemeMode();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <StyledNav>
      <Logo src={isDarkMode ? logoDarkUrl : logoLightUrl} height={40} alt="Mend Signal" />

      <Tooltip title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}>
        <IconButton onClick={() => toggle()} color="inherit" size="small">
          {isDarkMode ? <LightMode /> : <DarkMode />}
        </IconButton>
      </Tooltip>
    </StyledNav>
  );
}

export function Layout() {
  return (
    <>
      <Nav />

      <Content>
        <Outlet />
      </Content>
    </>
  );
}

export function Error() {
  return (
    <>
      <Nav />

      <Content>
        <StatusMessageRoot
          title="Something went wrong"
          description={
            <StatusMessageDescription>
              Please try refreshing the page, or reach out to our support team at{' '}
              <Link href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</Link> if it
              continues.
            </StatusMessageDescription>
          }
          faIcon={faFaceAnxiousSweat}
        />
      </Content>
    </>
  );
}
